import { ConnectToCrmWidgetData, ConnectToCrmWidgetValue } from '../../types'
import { WidgetService } from './widgetService'
import { ReadableWidgetService } from './interfaces/readableWidgetService'

interface ConnectToCrmWidgetService extends WidgetService {
  /**
   * Set the value of the widget. Updates the timestamp as well.
   * @param value The new value
   */
  setValue(value: ConnectToCrmWidgetValue[]): void
}

/**
 * Create a Widget Service for a "Connect to CRM" Widget
 * @param widget The widget data
 * @returns The Widget Service instance
 * @story User Story #11267: Connect to CRM widget: UI
 */
export const connectToCrmWidgetService = (widget: ConnectToCrmWidgetData): ConnectToCrmWidgetService => {
  // Return the service instance
  return {
    setValue(value) {
      widget.value = value
      widget.updatedAt = Date.now()
    },
  }
}
